export default {
  'FourPChart.title': '4P analyze',
  'FourPChart.place': 'Place',
  'FourPChart.promotion': 'Promotion',
  'FourPChart.product': 'Product',
  'FourPChart.price': 'Price',
  'FourPChart.noData': 'No data',
}
